import ContactScoresAPI from 'dashboard/api/pipelines/contactScores';

const state = {
  scores: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getScore: _state => contactId => _state.scores[contactId] || null,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetchScore: async ({ commit }, { accountId, contactId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ContactScoresAPI.getScore(accountId, contactId);
      const score = response.data?.data;
      if (score) commit('SET_SCORE', { contactId, score });
    } catch {
      // contact may not have a score yet
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_SCORE(_state, { contactId, score }) {
    _state.scores = { ..._state.scores, [contactId]: score };
  },

  CLEAR_SCORE(_state, contactId) {
    const { [contactId]: _, ...rest } = _state.scores;
    _state.scores = rest;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
